import type { BlockCMS } from '@/types'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
interface ModuleBannerL2Type {
  data: BlockCMS
  order: number
}
const ModuleBannerL2 = ({ data, order }: ModuleBannerL2Type) => {
  return (
    <section
      id={data._id}
      className={`${data?.type} ${data?.hideBot ? '' : 'pb-[20px]'} ${
        'order-[' + (order + 1) + ']'
      } scroll-mt-[160px]`}
    >
      <div className='mx-[-16px] flex'>
        <div className='max-w-[66.6666%] flex-[66.6666%] px-3'>
          <div className='grid w-full grid-cols-2 gap-5'>
            {data &&
              data.data.slice(0, 2).map((e, i) => {
                return (
                  <Link
                    href={e.path ? e.path : '/'}
                    className='block w-full'
                    key={i}
                  >
                    <ImageOptimize
                      src={e.image || ''}
                      alt=''
                      width='0'
                      height='0'
                      sizes='100%'
                      className='h-auto w-full rounded'
                    />
                  </Link>
                )
              })}
          </div>
        </div>
        <div className='max-w-[33.3333%] flex-[33.3333%] px-3'>
          <div className='flex flex-col flex-wrap justify-between gap-5'>
            {data &&
              data.data.slice(2, 4).map((e, i) => {
                return (
                  <Link
                    href={e.path ? e.path : '/'}
                    className='block w-full'
                    key={i}
                  >
                    <ImageOptimize
                      src={e.image || ''}
                      alt=''
                      width='0'
                      height='0'
                      sizes='100%'
                      className='h-auto w-full rounded'
                    />
                  </Link>
                )
              })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ModuleBannerL2
